export default __webpack_public_path__ + "static/media/arrow-right-ios.518e65c4.svg";